/**
 * Store for API call logs. Used by axios/fetch interceptors and BackendLogsPanel.
 * Subscribers (React components) re-render when new logs are added.
 */

import { useState, useEffect } from "react";

const MAX_LOGS = 200;

function getEndpointAndEnv(url) {
  if (!url || typeof url !== "string") return { endpoint: url || "?", env: "unknown" };
  try {
    const u = new URL(url);
    const path = u.pathname + (u.search || "");
    const host = u.hostname || "";
    const env = host.includes("birdnest")
      ? "prod"
      : host.includes("devde")
        ? "dev"
        : host === "localhost" || host === "127.0.0.1"
          ? "local"
          : "unknown";
    return { endpoint: path || "/", env };
  } catch {
    return { endpoint: url, env: "unknown" };
  }
}

let logs = [];
const listeners = new Set();

function addLog(entry) {
  const withMeta = {
    id: Date.now() + Math.random(),
    ts: new Date().toLocaleTimeString(),
    ...entry,
  };
  logs = [withMeta, ...logs].slice(0, MAX_LOGS);
  listeners.forEach((cb) => cb());
}

function getLogs() {
  return [...logs];
}

function subscribe(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

function getLogsCount() {
  return logs.length;
}

function useLogsCount() {
  const [count, setCount] = useState(logs.length);
  useEffect(() => {
    return subscribe(() => setCount(logs.length));
  }, []);
  return count;
}

export { addLog, getLogs, subscribe, getLogsCount, useLogsCount, getEndpointAndEnv };
